import React from 'react';
import enhance from './CompleteDeals.enhancer';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import InfluencerDealItem from '../../company/influencerDealItem';

class ContentComplete extends React.Component {
  constructor() {
    super();

    this.initialState = {};

    this.state = {
      ...this.initialState
    };
  }

  render() {
    const { classes, campaign, deals, openViewProposal } = this.props;

    return (
      <React.Fragment>
        {deals &&
          deals.length > 0 &&
          deals.map(deal => (
            <React.Fragment>
              <InfluencerDealItem
                deal={deal}
                openViewProposal={openViewProposal}
              />
              <Divider />
            </React.Fragment>
          ))}
        {!deals ||
          (deals && !deals.length && (
            <Typography
              align="center"
              justify="center"
              variant="h6"
              className={classes.noData}
            >
              No complete deals
            </Typography>
          ))}
      </React.Fragment>
    );
  }
}

export default enhance(ContentComplete);



// WEBPACK FOOTER //
// ./src/components/campaign/deals/CompleteDeals.js